










































import { Vue, Component } from 'vue-property-decorator'
import VueBase from '@/lib/vuebase'
import ajax from '@/lib/ajax'
import util from '@/lib/util'
import pageRequest from '@/store/models/page-request'
import { Dialog } from 'vant'
@Component({})
export default class StatementManager extends VueBase {
	loading: boolean = false
	finished: boolean = false
	error: boolean = false
	page: number = 1
	pageSize: number = 10
	totalCount: number = 0
	dispatchList: Array<any> = []
	searchForm: pageRequest = new pageRequest()
	onClickLeft() {
		window.history.go(-1)
	}
	// 页面初次加载
	async onLoad() {
		this.error = false
		this.searchForm.page += 1
		if (this.totalCount !== 0 && this.dispatchList.length === this.totalCount) return
		await this.searchDispatchList()
	}
	addNew() {
		this.$router.push({ path: '/dispatchDetail' })
	}
	// 查询数据
	async searchDispatchList() {
		await ajax
			.get('/api/maintainrecord/list-page?IsStatement=true', { params: this.searchForm })
			.then((rep) => {
				this.dispatchList.push(...rep.data.result.items)
				this.totalCount = rep.data.result.total
				if (this.dispatchList.length === this.totalCount) this.finished = true
			})
			.catch(() => {
				this.error = false
			})
			.finally(() => {
				this.loading = false
			})
	}
	statementedBtn(val: any) {
		this.$router.push({ path: '/statementDetail?id=' + val.id })
	}
	async backBtn(val: any) {
		Dialog.confirm({
			title: '提示',
			message: '确定撤回吗',
		})
			.then(async () => {
				await ajax.post('/api/maintainrecord/maintain-record-dispatch-back/'+ val.id)
					.then(() => {
						this.$toast.success('撤回成功')
						window.location.reload()
					})
			})
			.catch(() => { })
	}
	changeBtn(val: any) {
		this.$router.push({ path: '/dispatchChange?id=' + val.id })
	}
	historyBtn(val: any) {
		this.$router.push({ path: '/maintainrecordhistory?vehicleNO=' + val.vehicleNO })
	}
	async created() {
		this.dispatchList = []
	}
}
